import React, { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { assessmentsQuery } from "../../../../utils/entitiesFiltersUtils";
import Widget from "../../../features/widget/Widget";
import iconsList from "../../../ui/icons/iconsList";
import AssessmentItem from "../../../features/assessmentItem/AssessmentItem";
import noAssessmentsImg from "../../../../../assests/emptyList/assessment.png";
import SectionList from "../myLearningDomainPage/SectionList/SectionList";
import classes from "./MyAssessmentsWidget.module.css";

const MyAssessmentsWidget = () => {

  const { texts } = useSelector((state) => state.translate);
  const assessments = useSelector((state) => selectEntitiesByFilters(state, assessmentsQuery));
  
  return (
    <Widget
      icon={iconsList.tasks}
      color="#FDDB71"
      title={assessments.length ? `${texts.assessments ?? ""} (${assessments?.length})` : texts.assessments}
      className={classes.MyAssessmentsWidget}
    >
      <div className={classes.warrpDiv}>
        <SectionList
          list={assessments}
          ItemComponent={AssessmentItem}
          classNameList={ assessments.length > 0 ? classes.AssessmentsList : classes.EmptyState}
          itemPropName="assessment"
          textForEmptyList={texts.noAssessments}
          imgEmptyList={noAssessmentsImg}
        />
      </div>
    </Widget>
  );
};

export default MyAssessmentsWidget;